import { render, staticRenderFns } from "./BrokerCreate.vue?vue&type=template&id=2152e331&scoped=true"
import script from "./BrokerCreate.vue?vue&type=script&lang=js"
export * from "./BrokerCreate.vue?vue&type=script&lang=js"
import style0 from "./BrokerCreate.vue?vue&type=style&index=0&id=2152e331&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2152e331",
  null
  
)

export default component.exports